const t = (...t) => t.flatMap((t => "string" == typeof t && "" !== t ? [ t ] : [])).join(" ");

export { t as default };
//# sourceMappingURL=index.js.map
